import React, { useCallback, useState } from 'react';
import { FormSectionTitle } from '../atoms/FormSectionTitle';
import { InputField } from '../atoms/InputField';
import { VisibilityButton } from 'atoms/VisibilityButton';
import { RequiredLabel } from './RequiredLabel';

type LabeledPasswordFieldProps = {
  title: string;
  inline?: boolean;
  id?: string;
  required?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;
export const LabeledPasswordField = React.forwardRef<HTMLInputElement, LabeledPasswordFieldProps>(
  (_props, ref) => {
    const [isShowPassword, setIsShowPassword] = useState(false);
    const onClickVisibilityIcon = useCallback(
      () => setIsShowPassword((isShowPassword) => !isShowPassword),
      [isShowPassword]
    );
    const { inline, title, id, required, ...props } = _props;

    return (
      <div className={inline ? 'inline-block' : 'block'}>
        <div className="flex items-center gap-2">
          <FormSectionTitle text={title} htmlFor={id} />
          {required && <RequiredLabel id={id} />}
        </div>
        <div className="relative w-[25rem] max-w-full box-border">
          <InputField
            type={isShowPassword ? 'text' : 'password'}
            ref={ref}
            {...props}
            className="w-[25rem] pr-10"
            id={id}
          />
          <VisibilityButton
            className="absolute top-2 right-3 cursor-pointer"
            isShow={!isShowPassword}
            onClick={onClickVisibilityIcon}
          />
        </div>
      </div>
    );
  }
);
LabeledPasswordField.displayName = 'LabeledPasswordField';
